angular.module('app.filters').filter('scoreboardMakeModel', function($filter) {
    return function(input) {
        if (!input.sport || !input.scoreboard_make || !input.scoreboard_model) {
            return '';
        }
        if (input.scoreboard_make == 'Manual') {
            return input.scoreboard_model; // "Manual Manual Input" is redundant in this case
        }
        return `${input.scoreboard_make} ${input.scoreboard_model}`;
    };
});


// WEBPACK FOOTER //
// ./filters/scoreboard_make_model.js